import { useState, useEffect } from "react";

const getHashedValue = async (rawValue: string) => {
  const encoded = new TextEncoder().encode(rawValue);
  const hashed = await crypto.subtle.digest("SHA-256", encoded);
  return [...new Uint8Array(hashed)]
    .map((value) => value.toString(16).padStart(2, "0"))
    .join("");
};

export const useHashedValue = (value?: string) => {
  const [hashedValue, setHashedEmail] = useState<string | undefined>(undefined);
  useEffect(() => {
    if (value) {
      getHashedValue(value).then(setHashedEmail);
    }
  }, [value]);

  return hashedValue;
};
